export default {
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 16,
  },
  checkContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  buttonContainer: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  flexColumn: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
   previewButton: {
    marginTop: 10,
    alignSelf: 'flex-end',
  },

};
